import React from 'react';
import Typography from '@material-ui/core/Typography';
import { NotificationManager } from 'react-notifications';
import LoggedInContainer from '../../components/loggedInContainer/loggedInContainer';
import CreateProductForm from '../../components/createProductForm/createProductForm';
import ProductsList from '../../components/productsList/productsList';
import http from '../../services/http';

class CreateProductPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { products: [] };
  }

  componentDidMount() {
    this.getProductList();
  }

  getProductList = async () => {
    try {
      const products = await http.get('/api/admin/getproducts');

      this.setState({
        products,
      });
    } catch (err) {
      console.error(err);
      NotificationManager.error('Nie udało się pobrać listy produktów', 'Błąd', 5000);
    }
  }

  deleteProduct = async ({ name, id }) => {
    try {
      await http.delete('/api/admin/deleteproduct', { id });
      this.getProductList();

      NotificationManager.success(`Usunięto produkt: ${name}`, 'Sukces', 5000);
    } catch (err) {
      console.error(err);
      NotificationManager.error(`Nie udało się usunąć produktu: ${name}`, 'Błąd', 5000);
    }
  }

  render() {
    const { products } = this.state;

    return (
      <LoggedInContainer>
        {!!products.length && (
          <div>
            <div className="page-title">
              <Typography variant="h5">
                Dostępne produkty
              </Typography>
            </div>
            <ProductsList products={products} onDelete={this.deleteProduct} />
          </div>
        )}
        <div className="page-title">
          <Typography variant="h5">
            Dodaj produkt
          </Typography>
        </div>
        <CreateProductForm onCreate={this.getProductList} />
      </LoggedInContainer>
    );
  }
}

export default CreateProductPage;
